export default "# Character Sheet\n\n## Mini Preview\n\n::demo{name=characterMini}"